import React, { useState } from 'react';
import {
  Box,
  Flex,
  SimpleGrid,
  Stack,
  Text,
  Center,
  Button,
  LinkOverlay,
  Image,
  useBoolean,
} from '@chakra-ui/react';
import { t } from 'i18n';

import NumberFormat from 'react-number-format';
import { useNFTsByIDs } from '../../api/query';
import userStore from '../../stores/account';
import { streamApi } from '../../api/contracts';
import { ToastProps } from '../../utils/types';
import { toast, formatBalance, toFixed, timeformater } from '../../utils';
import cardBgImg from '../../assets/card-bg.png';

export default function Comp(props: any) {
  const [flag, setFlag] = useBoolean();
  const [index, setIdx] = useState(-1);

  const { nfts = [], cb = {}, vestingId, token, vesting = {} } = props;
  const { stopTime = null } = vesting;
  const isFinish = stopTime * 1000 - new Date().getTime() <= 0;

  const { tokenNumsMap = {} } = userStore.useState('tokenNumsMap');
  const tokenNumMap: any = tokenNumsMap;
  const { isLoading, data = [] } = useNFTsByIDs(nfts);

  const [loading, setLoading] = useState(false);

  const handleClaim = async (nftId: string) => {
    try {
      // ReactGA.event({
      //   category: formType,
      //   action: `${formType} fund`,
      //   value: amount,
      // });
      const stream = streamApi();
      const toastProps: ToastProps = {
        title: 'Transaction',
        desc: '',
        status: 'success',
      };
      setLoading(true);
      const cbs = {
        receipt: () => {
          toastProps.desc = t(`claim.success`);
          toast(toastProps);
          setLoading(false);
          // ReactGA.event({
          //   category: formType,
          //   action: `${formType} fund success`,
          //   value: amount,
          // });
          // refetch();
          if (cb) {
            cb();
          }
        },
        error: () => {
          setLoading(false);
        },
      };
      await stream.claimByNFT(vestingId, nftId, cbs);

      return null;
    } catch (e: any) {
      // console.log(error);
      const toastProps = {
        title: '',
        desc: '',
        duration: 6000,
        status: 'info',
      };
      toastProps.title = 'Error';
      toastProps.desc = e.message;
      toastProps.status = 'error';
      toast(toastProps);
      setLoading(false);
      return null;
    }
    // fetchData()
  };

  return (
    <SimpleGrid columns={[1, 2, 2, 2, 2, 2]} spacing="11px">
      {data.map((nft: any, idx: any) => {
        const { id, name, image } = nft;
        const { claimable = 0, remain = 0 } = tokenNumMap[id];

        return (
          <Flex
            onMouseEnter={() => {
              setIdx(idx);
              setFlag.on();
            }}
            onMouseLeave={() => {
              setIdx(-1);
              setFlag.off();
            }}
            py={3}
            px={2.5}
            key={idx}
            minW="440px"
            h="148px"
            borderRadius="12px"
            boxShadow="0px 0px 10px rgba(0, 0, 0, 0.16)"
          >
            <Box pos="relative" minW="128px" mr={2.5} cursor="pointer">
              <Image
                zIndex={20}
                borderRadius="10px"
                src={image}
                w="128px"
                h="128px"
                objectFit="cover"
              />
              {idx === index && flag ? (
                <Center
                  pos="absolute"
                  bgColor="rgba(255, 255, 255, 0.39)"
                  zIndex={30}
                  top={0}
                  w="128px"
                  h="128px"
                >
                  <Button
                    w="120px"
                    h="36px"
                    borderWidth="2px"
                    bgColor="linear-gradient(90deg, #00E0B5 0%, #00D392 100%);"
                    borderRadius="100px"
                    onClick={() => {
                      handleClaim(id);
                    }}
                    isLoading={loading}
                    boxShadow="0px 3px 6px rgba(0, 0, 0, 0.16)"
                    borderColor="#D3FFF7"
                    fontWeight="bold"
                    fontSize="18px"
                  >
                    CLAIM
                  </Button>
                </Center>
              ) : (
                ''
              )}
            </Box>
            <Stack w="100%" spacing={0}>
              <Box h="65px" mb={-2.5}>
                <Text as="div" mb={0.5} textAlign="left" fontSize="16px" fontWeight="bold">
                  {name}
                </Text>
                {!isFinish ? (
                  <Text as="div" textStyle="desc" textColor="#999999">
                    {`Linearly vesting will finish on ${timeformater(stopTime, 'YYYY-MM-DD')}`}
                  </Text>
                ) : (
                  <Box h="16px"> </Box>
                )}
              </Box>

              <Box textAlign="right">
                <Text textStyle="label" textColor="primary" fontSize="12px" mb={-1.5}>
                  {t('claimable', { name: token })}
                </Text>
                <Box textStyle="value" textColor="primary" fontSize="16px">
                  <NumberFormat
                    value={toFixed(claimable)}
                    displayType={'text'}
                    thousandSeparator={true}
                    renderText={(value) => {
                      const numArr = value.split('.');
                      return (
                        <>
                          {numArr[0]}
                          {numArr[1] && (
                            <Text as="span" fontSize="12px">
                              .{numArr[1]}
                            </Text>
                          )}
                        </>
                      );
                    }}
                  />
                </Box>
              </Box>
              <Box textAlign="right">
                <Text textStyle="label" fontSize="12px" mb={-1.5}>
                  {t('locked.title', { name: token })}
                </Text>
                <Box textStyle="value" fontSize="16px">
                  <NumberFormat
                    value={toFixed(remain - claimable)}
                    displayType={'text'}
                    thousandSeparator={true}
                    renderText={(value) => {
                      const numArr = value.split('.');
                      return (
                        <>
                          {numArr[0]}
                          {numArr[1] && (
                            <Text as="span" fontSize="12px">
                              .{numArr[1]}
                            </Text>
                          )}
                        </>
                      );
                    }}
                  />
                </Box>
              </Box>
            </Stack>
          </Flex>
        );
      })}
    </SimpleGrid>
  );
}
